import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex align-start ga-3 mb-4" }
const _hoisted_2 = { class: "text-subtitle-2 font-weight-bold" }
const _hoisted_3 = { class: "flex-grow-1" }
const _hoisted_4 = { class: "text-h6 font-weight-bold" }
const _hoisted_5 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis mt-1 mb-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    color: "background",
    variant: "elevated",
    elevation: "4",
    rounded: "lg",
    class: "pa-6 mb-4"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.n != null)
          ? (_openBlock(), _createBlock(_component_v_avatar, {
              key: 0,
              color: "primary",
              variant: "tonal",
              size: "28",
              rounded: "lg"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.n), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.title), 1),
          (_ctx.hint)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.hint), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.n != null ? 'pl-10' : '')
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ]),
    _: 3
  }))
}